<ng-container #viewContainer></ng-container>

<ng-template #cardView>
  <app-card-data-view
    (paymentData)="processTransaction($event)"
    [whiteLabelInfo]="whiteLabelInfo"
  ></app-card-data-view>
</ng-template>
<ng-template #tokenView>
  <app-card-token-view
    (OTP)="authorizeCardTxn($event)"
    (emitResendOtp)="resendOtp()"
    [otpError]="otpError"
    [whiteLabelInfo]="whiteLabelInfo"
  ></app-card-token-view>
</ng-template>
<ng-template #visaView>
  <app-visa-transactions
    [visaResponse]="visaResponse"
    [paymentDetails]="paymentDetails"
    (emitErrorView)="setView('error', $event)"
    (emitResponse)="setTxnStatusMessage($event)"
  ></app-visa-transactions>
</ng-template>
<ng-template #challengeView>
  <div #challengeContainer id="challenge-container"></div>
</ng-template>

<!-- <ng-template #loadingView>
  <div class="text-center">
    <div
      class="spinner-border spinner-border"
      style="width: 10rem; height: 10rem"
      role="status"
    >
      <span class="sr-only">Processing Transaction..</span>
    </div>
    <br /><br />
    <p style="color: black">Loading</p>
  </div>
</ng-template> -->

<ng-template #errorView>
  <div class="text-center">
    <div class="error-response">
      <img class="mb" src="../../../assets/rexpay/Failed.svg" alt="" />
      <div>
        {{ errorResponse }}
      </div>
    </div>
  </div>
</ng-template>

<app-error-dialog
  [error]="header"
  [message]="subHeader"
  [visible]="showModal"
  (closed)="showModal = false"
/>
